import { yup } from '@framework/validation';
import { RuleType } from '../../IRule';
import { IRuleType } from '../../IRuleType';
import { PositiveRuleComponent } from './PositiveRuleComponent';

const configValidator = yup
  .object({
    value: yup.boolean().notRequired().label('Numero positivo'),
    customMessage: yup
      .string()
      .notRequired()
      .label('Messaggio personalizzato di validazione'),
  })
  .notRequired()
  .noUnknown();

type IRulePositiveType = yup.InferType<typeof configValidator>;

export const PositiveRule: IRuleType<IRulePositiveType> = {
  type: RuleType.Positive,
  name: 'Numero positivo',
  configComponent: PositiveRuleComponent,
  configValidator: configValidator,
  validator: (schema, rule) => {
    if (!rule?.value) return schema;

    return (schema as yup.NumberSchema).positive(
      rule.customMessage ?? undefined,
    );
  },
};
